import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const OptionItemNew = ({
                         language,
                         onAdd
                       }) => {
  const inputRef = useRef("");

  const handleChange = () => {
    if (!inputRef.current.value) {
      return;
    }
    onAdd({
      value: inputRef.current.value,
      language,
    });

    inputRef.current.value = "";
  };

  return (
    <div className="input-group input-group-sm mb-2">
      <input
        ref={inputRef}
        className="form-control form-control-sm"
        type="text"
        placeholder="Please fill input then press + button"
      />
      <div className="input-group-append">
        <button className="btn btn-sm btn-outline-success" onClick={handleChange}>
          <FontAwesomeIcon icon={faPlus}/>
        </button>
      </div>
    </div>
  );
};

export default OptionItemNew;



// WEBPACK FOOTER //
// ./src/views/pages/stories/OptionItemNew.js